














































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { Card, Button } from 'element-ui';
import billModal from '@/components/modals/bill/BillModal.vue';
import omit from 'lodash/omit';
import { BillFields, BillInput } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'bill-modal': billModal,
    'el-button': Button,
    'el-card': Card
  }
})
export default class Detail extends Vue {
  @Prop() private bill!: BillFields;

  private billInput: BillInput = {};

  private openModal(): void {
    this.$store.commit('Bill/setUpdateModalBaseProps', omit(this.bill, ['pdfFile']));
  }

  private billLanguage() {
    return this.bill.language === 'en' ? this.$t('languages.en') : this.$t('languages.ja');
  }

  @Watch('$store.state.Bill.billModalBaseProps')
  private setUpdateModalBaseProps(billModalBaseProps: BillInput) {
    this.billInput = billModalBaseProps;
  }
}
